import React, { useEffect, useState } from "react";

import {
  Typography,
  CircularProgress,
  Button,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { useApi } from "../hooks/useApi";

const RemoveServiceDialog = ({
  showRemoveServiceDialog,
  setShowRemoveServiceDialog,
  selectedService,
  showServiceAlert,
  setServiceShowAlert,
  onSave,
}) => {
  const api = useApi();

  const [service, setService] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    setService({ id: selectedService?.id });
  }, [selectedService]);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setShowRemoveServiceDialog(false);
    }
  };

  const removeService = async () => {
    setIsSubmitting(true);
    setShowAlert({ show: false, message: "", type: "" });

    try {
      await api("/tenants/services.php", {
        method: "DELETE",
        body: JSON.stringify(service),
      });

      setServiceShowAlert({
        show: true,
        message: "Successfully removed service.",
        type: "success",
      });
      setShowRemoveServiceDialog(false);
      onSave();
    } catch (err) {
      setShowAlert({ show: true, message: err.message, type: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={showRemoveServiceDialog}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>
        Remove Service?
        <IconButton
          //disabled={isSubmitting}
          aria-label="close"
          onClick={() => setShowRemoveServiceDialog(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {showAlert.show === true && (
          <Alert sx={{ mb: 2 }} severity={showAlert.type}>
            {showAlert.message}
          </Alert>
        )}
        <Typography variant="body2">
          Are you sure you want to remove this service? This action cannot be
          undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setShowRemoveServiceDialog(false)}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => removeService()}
          disabled={isSubmitting}
          color="error"
        >
          {isSubmitting ? (
            <CircularProgress
              enableTrackSlot
              size="25px"
              sx={{ color: "text.primary" }}
            />
          ) : (
            "Remove"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveServiceDialog;
